import { shouldValidateVatIdViaVies } from '../utils/eu-countries.ts';
import { normalizeVatId, VAT_ID_PATTERN } from '../utils/vat-id.ts';
import * as yup from 'yup';

export function vatIdSchema() {
  return yup
    .string()
    .transform((value) => normalizeVatId(value))
    .when('country', {
      is: (country: string | undefined) => shouldValidateVatIdViaVies(country),
      then: (schema) =>
        schema.matches(VAT_ID_PATTERN, {
          message: 'VAT ID must look like DE123456789',
          excludeEmptyString: true,
        }),
    });
}
